/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

// Flow
// As a [first time user] I come to shop.eataly.ca and see a welcome message and postal code input
// When I enter my Toronto postal code, the header shows up and the messaging changes

// As a [first time user] I come to shop.eataly.ca and see a welcome message and postal code input
// When I enter a postal code outside of Toronto, the messaging changes and I see a subscribe input

// const LOCATION_KEY = 'shoppingLocation';
// const EATALY_CANADA_URL = 'https://eataly-canada.myshopify.com';
const GTA_KEY = "GTA";
const CAN_KEY = "CAN";
const TESTING_CODE = "welcometest";
const TORONTO_POSTAL_CODE_PREFIXES = [
  "L4W",
  "L6V",
  "M8V",
  "M6C",
  "M3A",
  "M5E",
  "M4C",
  "M1B",
  "L3R",
  "L3P",
  "L3T",
  "L4B",
  "L4H",
  "L4X",
  "L6W",
  "M8W",
  "M6E",
  "M4A",
  "M6K",
  "M4B",
  "M1S",
  "L6C",
  "L3S",
  "L4J",
  "L4C",
  "L4L",
  "L4Y",
  "L6X",
  "M8X",
  "M6M",
  "M6A",
  "M7Y",
  "M4J",
  "M1T",
  "L6G",
  "L6B",
  "L4S",
  "L4K",
  "L4Z",
  "L6Y",
  "M9A",
  "M6N",
  "M3B",
  "M5G",
  "M4G",
  "M1W",
  "L6E",
  "L4E",
  "L6A",
  "L5R",
  "L6Z",
  "M9B",
  "M9N",
  "M6B",
  "M6G",
  "M4H",
  "M1V",
  "L5A",
  "L7A",
  "M8Y",
  "M3C",
  "M4Y",
  "M1X",
  "L5B",
  "L6P",
  "M8Z",
  "M2H",
  "M5V",
  "M1J",
  "L5C",
  "L6R",
  "M9C",
  "M3H",
  "M5L",
  "M1K",
  "L5K",
  "L6S",
  "M9P",
  "M2J",
  "M4S",
  "M1L",
  "L5L",
  "L6T",
  "M9R",
  "M3J",
  "M4P",
  "M1M",
  "L5E",
  "M9V",
  "M2K",
  "M6H",
  "M1N",
  "L5G",
  "M9W",
  "M3K",
  "M5X",
  "M1P",
  "L5H",
  "M2L",
  "M5P",
  "M1R",
  "L5J",
  "M3L",
  "M5B",
  "M1C",
  "L5M",
  "M6L",
  "M5J",
  "M1E",
  "L5N",
  "M9L",
  "M6P",
  "M1G",
  "L5W",
  "M2M",
  "M4L",
  "M1H",
  "L5V",
  "M3M",
  "M5T",
  "M7R",
  "M5M",
  "M4N",
  "M9M",
  "M6J",
  "M2N",
  "M4T",
  "M3N",
  "M4R",
  "M2P",
  "M6R",
  "M2R",
  "M7A",
  "M5A",
  "M5H",
  "M4W",
  "M5N",
  "M6S",
  "M5C",
  "M4X",
  "M5W",
  "M4M",
  "M4V",
  "M5R",
  "M4E",
  "M4K",
  "M5K",
  "M5S",
  "L6H",
];

$(() => {
  const shoppingLocation = localStorage.getItem(LOCATION_KEY);

  displayView(shoppingLocation);

  // CTA BUTTONS (hero first-time-view)
  $('[data-action="shop-local"]').on("click", (e) => {
    e.preventDefault();
    localStorage.setItem(LOCATION_KEY, GTA_KEY);
    displayView(GTA_KEY);
  });

  $('[data-action="shop-shipping"]').on("click", (e) => {
    e.preventDefault();
    window.top.location.href = "https://shopcanada.eataly.ca/?loc=can";
  });

  $(".search-postal-code-btn").on("click", (e) => {
    e.preventDefault();
    localStorage.removeItem(LOCATION_KEY);
    window.location.reload();
  });
});

// Based on the location, show the appropriate view
const displayView = (location, confirmed = false) => {
  if (!location) {
    $(".first-time-view").fadeIn(100);
  } else if (location.toUpperCase() === "GTA") {
    $(".first-time-view").hide(); // Hide First Time View
    $(".canada-view").hide(); // Hide Canada View
    $(".toronto-view").fadeIn(500);
    $("#shopify-section-header").fadeIn(500); // Show Header
    if (confirmed) {
      $(".toronto-view .postal-code-form").hide();
      $(".toronto-view .location-confirmed").fadeIn(500);
    }
  } else if (location.toUpperCase() === "CAN") {
    // $('.first-time-view').hide(); // Hide First Time View
    // $('.toronto-view').hide(); // Hide First Time View
    // $('#shopify-section-header').hide(); // Hide Header
    // $('.canada-view').fadeIn(500);
    window.top.location.href = "https://shopcanada.eataly.ca/?loc=can";
  } else {
    localStorage.removeItem("shoppingLocation");
    $(".toronto-view").hide(); // Hide Toronto View
    $(".canada-view").hide(); // Hide Canada View
    $(".first-time-view").fadeIn(500);
  }
};

const handlePostalCodeSubmit = (postalCode) => {
  if (!postalCode) {
    return;
  }
  if (postalCode === TESTING_CODE) {
    localStorage.removeItem(LOCATION_KEY);
    window.location.reload();
    return;
  }
  const current = localStorage.getItem(LOCATION_KEY);
  const location =
    TORONTO_POSTAL_CODE_PREFIXES.indexOf(
      postalCode.slice(0, 3).toUpperCase(),
    ) === -1
      ? CAN_KEY
      : GTA_KEY;
  localStorage.setItem(LOCATION_KEY, location);
  displayView(location, current == location);
};

// ### To intercept clicks on the Welcome page
// function interceptClickEvent(e) {
//   var href;
//   var target = e.target || e.srcElement;
//   if (target.tagName === 'A') {
//       href = target.getAttribute('href');
//       const location = localStorage.getItem(LOCATION_KEY);

//       if (location != 'GTA') {

//       }
//       //put your logic here...
//       console.log({ location })
//       //tell the browser not to respond to the link click
//       e.preventDefault();
//       // if (location === 'GTA') {
//       // }
//   }
// }
// $(() => {
//   //listen for link click events at the document level
//   if (document.addEventListener) {
//     document.addEventListener('click', interceptClickEvent);
//   } else if (document.attachEvent) {
//     document.attachEvent('onclick', interceptClickEvent);
//   }
// })

// ### Redirect script for when eataly-canada goes live
// const LOCATION_KEY = 'shoppingLocation';
// const EATALY_CANADA_URL = 'https://eataly-canada.myshopify.com';

// function getParameterByName(name, url) {
//     if (!url) url = window.location.href;
//     name = name.replace(/[\[\]]/g, '\\$&');
//     var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
//         results = regex.exec(url);
//     if (!results) return null;
//     if (!results[2]) return '';
//     return decodeURIComponent(results[2].replace(/\+/g, ' '));
// }

// if (getParameterByName('loc').toUpperCase() === 'GTA') {
//   localStorage.setItem(LOCATION_KEY, 'GTA');
// }

// if (localStorage.getItem(LOCATION_KEY) === 'CAN') {
//   window.top.location.href = EATALY_CANADA_URL;
// }
